import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

export default function SiteGSC() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [days, setDays] = useState(30);

  useEffect(() => { loadData(); }, [id, days]);

  async function loadData() {
    setLoading(true);
    setError(null);
    try {
      const result = await api.getGSCPerformance(id, days);
      setData(result);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  }

  if (loading) return <div className="loading">טוען נתוני Search Console...</div>;
  if (error) return (
    <div className="placeholder-page">
      <div className="icon">⚠️</div>
      <h2>שגיאה בטעינת נתונים</h2>
      <p>{error}</p>
    </div>
  );
  if (!data || !data.rows) return <div className="loading">אין נתונים</div>;

  const totalClicks = data.rows.reduce((sum, r) => sum + r.clicks, 0);
  const totalImpressions = data.rows.reduce((sum, r) => sum + r.impressions, 0);
  const avgCTR = totalImpressions > 0 ? ((totalClicks / totalImpressions) * 100).toFixed(1) : 0;
  const avgPosition = data.rows.length > 0
    ? (data.rows.reduce((sum, r) => sum + r.position, 0) / data.rows.length).toFixed(1)
    : '-';

  return (
    <>
      {/* Metric Cards */}
      <div className="site-overview-header">
        <div className="site-metric-card animate-in stagger-1">
          <div className="label">קליקים ({days} יום)</div>
          <div className="value-row">
            <div className="value" style={{color:'var(--accent)'}}>{totalClicks.toLocaleString()}</div>
          </div>
        </div>
        <div className="site-metric-card animate-in stagger-2">
          <div className="label">חשיפות</div>
          <div className="value-row">
            <div className="value">{totalImpressions.toLocaleString()}</div>
          </div>
        </div>
        <div className="site-metric-card animate-in stagger-3">
          <div className="label">CTR ממוצע</div>
          <div className="value-row">
            <div className="value" style={{color:'var(--green)'}}>{avgCTR}%</div>
          </div>
        </div>
        <div className="site-metric-card animate-in stagger-4">
          <div className="label">מיקום ממוצע</div>
          <div className="value-row">
            <div className="value" style={{color:'var(--yellow)'}}>{avgPosition}</div>
          </div>
        </div>
      </div>

      {/* Date Filter */}
      <div className="filter-row" style={{marginBottom:'16px'}}>
        {[7, 14, 30, 90].map(d => (
          <div key={d} className={`filter-chip ${days === d ? 'active' : ''}`}
            onClick={() => setDays(d)}>{d} ימים</div>
        ))}
        <div className="filter-spacer" />
        <span style={{fontSize:'12px',color:'var(--text-muted)'}}>
          {data.start_date} - {data.end_date} · {data.total_rows} ביטויים
        </span>
      </div>

      {/* Queries Table */}
      <div className="section-card animate-in">
        <div className="section-header">
          <div className="section-title">ביטויי חיפוש - Search Console</div>
        </div>
        <table className="rankings-table">
          <thead>
            <tr>
              <th>ביטוי</th>
              <th>קליקים</th>
              <th>חשיפות</th>
              <th>CTR</th>
              <th>מיקום</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.slice(0, 50).map((row, i) => {
              const query = row.keys ? row.keys[0] : row.query || '-';
              const pos = row.position ? row.position.toFixed(1) : '-';
              const posClass = row.position <= 3 ? 'top3' : row.position <= 10 ? 'top10' : row.position <= 20 ? 'top20' : 'beyond';

              return (
                <tr key={i}>
                  <td><span className="keyword-text">{query}</span></td>
                  <td><span className="metric-val" style={{color:'var(--accent)'}}>{row.clicks}</span></td>
                  <td><span className="metric-val">{row.impressions.toLocaleString()}</span></td>
                  <td><span className="metric-val">{row.ctr ? row.ctr.toFixed(1) : '0'}%</span></td>
                  <td><span className={`position-badge ${posClass}`}>{pos}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
